import * as React from 'react';
import { SingleValueComponent, LabelConfig } from '../common';
import { escapeUrl } from 'app/components/favourite-layout/favourite/common/utils';

/**
 * Link to internal or external url. Opened in new tab or window.
 */
export interface LinkProps extends Partial<SingleValueComponent<string>> {
  /**
   * @internal
   */
  url?: string;
  /**
   * Overrides the displayed link text if no label.text is provided
   */
  linkText?: string;
  /**
   * Standard label config. label.text is the primary source for displayed link text.
   */
  label?: LabelConfig;
  /**
   * @internal
   */
  urlFromTemplateString?: string;
  /**
   * Optional styles.
   *
   * @internal
   */
  style?: any;
}

/**
 * Component to open a link with target _blank
 */
export const Link: React.FC<LinkProps> = (props) => {
  const {
    componentId,
    children,
    className,
    url,
    linkText,
    value,
    label,
    style,
    urlFromTemplateString
  } = props;

  const linkUrl = url || urlFromTemplateString;
  const displayText = label && label.text ? label.text : linkText || value || linkUrl;
  return linkUrl ? <a
    id={componentId}
    className={className}
    style={style}
    target="_blank"
    rel="noopener noreferrer"
    href={escapeUrl(linkUrl)}
  >
    {children || displayText}
  </a> : <div className={className} style={style}>{children || displayText}</div>;
};
